<script>
import store from '@/store'
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    code: {
      type: '',
      default: ''
    }
  },
  render (h, context) {
    // console.log('context', context)
    const { icon, title, code } = context.props
    const vnodes = []
    if (icon) {
      if (icon.includes('el-icon')) {
        vnodes.push(<i class={[icon, 'sub-el-icon']} />)
      } else {
        vnodes.push(<svg-icon icon-class={icon} />)
      }
    }

    if (title) {
      let count = store.state.ques.reviewCount
      let translateCount = store.state.enque.translateCount
      vnodes.push(
        <span slot='title'>{(title)}
          <el-badge is-dot={code === '10120201' && count !== 0} class="item" ></el-badge>
          <el-badge is-dot={code === '10120301' && translateCount !== 0} class="item" ></el-badge>
        </span>)
    }
    return vnodes
  }
}
</script>

<style scoped>
.sub-el-icon {
  color: currentColor;
  width: 1em;
  height: 1em;
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/Item.vue